import { apiJson } from "../utils/api";

function errDetail(data, fallback) {
  const d = data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join("；");
  return fallback;
}

export async function fetchLoveLanguagesMeta() {
  const { res, data } = await apiJson("/api/love-languages/meta");
  if (!res.ok) throw new Error(errDetail(data, "加载失败"));
  return data;
}

export async function fetchLoveLanguagesQuestions() {
  const { res, data } = await apiJson("/api/love-languages/questions");
  if (!res.ok) throw new Error(errDetail(data, "加载题目失败"));
  return data;
}

export async function submitLoveLanguagesAnswers(answers) {
  const { res, data } = await apiJson("/api/love-languages/submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ answers }),
  });
  if (!res.ok) throw new Error(errDetail(data, "提交失败"));
  return data;
}
